
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "ShoppingIngredientListItem",
  props: {
    /** ID */
    id: {
      type: Number,
      required: true
    },
    /** foodId */
    foodId: {
      type: Number,
      required: true
    },
    /** チェック状態 */
    check: {
      type: Boolean,
      required: true
    },
    /** 食材名 */
    ingredientName: {
      type: String,
      required: true
    },
    /** 在庫有無 */
    hasStock: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    if (props.ingredientName == "えのき") {
      NativeClient.sendDebugLog("ShoppingIngredientListItem hasStock = " + props.hasStock);
    }
    /**
     * チェックアイコンを取得する
     */
    const getCheckImage = () => {
      if (props.check) {
        return require("@/assets/images/icn-check-on.png");
      }
      return require("@/assets/images/icn-check-off.png");
    };

    const textDecoration = computed(() => {
      if (props.check) {
        return { textDecoration: 'line-through'};
      }
      return { textDecoration: 'none' };
    });

    // ボタン
    const tappedCheck = () => {
      NativeClient.sendDebugLog("ShoppingIngredientListItem clicked check id = " + props.id + ", send check = " + !props.check);
      context.emit("check-click", props.id, !props.check);
    };
    const tappedStock = () => {
      NativeClient.sendDebugLog("ShoppingIngredientListItem clicked stock id = " + props.id);
      context.emit("stock-click", props.id);
    };
    const tappedEdit = () => {
      if (!props.check) {
        NativeClient.sendDebugLog("ShoppingIngredientListItem clicked edit id = " + props.id);
        context.emit("edit-click", props.id, props.foodId);
      }
    };

    return {
      getCheckImage,
      textDecoration,
      tappedCheck,
      tappedStock,
      tappedEdit
    };
  }
});
